import { createContext, useContext } from 'react';

export type DepartmentText = (objectText: string, departmentText: string) => string;

/** Uses modern level-item wording until the viewer's default-only access is confirmed. */
export const objectText: DepartmentText = (text) => text;

/** Selects the historical Slovak department wording, including grammatical agreement. */
export const strediskoText: DepartmentText = (_objectText, text) => text;

export const DepartmentTerminologyContext = createContext<DepartmentText>(objectText);
export const CurrentDepartmentTextContext = createContext<DepartmentText>(objectText);

/** Selects application-authored copy without rewriting names or serialized values. */
export function useDepartmentText() {
  return useContext(DepartmentTerminologyContext);
}

/** Resolves current wording when a retained callback displays a notification. */
export function useCurrentDepartmentText() {
  return useContext(CurrentDepartmentTextContext);
}

/** Keeps retained dialog copy reactive while the viewer's hierarchy access changes. */
export function DepartmentLabel({ objectLabel, departmentLabel }: { objectLabel: string; departmentLabel: string }) {
  const departmentText = useDepartmentText();
  return <>{departmentText(objectLabel, departmentLabel)}</>;
}
